// extracted by mini-css-extract-plugin
export default {"wrapper":"UserAvatarLink_wrapper__tZWb+","name":"UserAvatarLink_name__+pQnQ","male":"UserAvatarLink_male__T3bVe","female":"UserAvatarLink_female__SuoSg"};